export interface IEmailTemplateTradeRequest {
  subject: string;
  text_header: string;
  email_has_been_sent_phrase: string;
}
